<script setup lang="ts"></script>

<template>
  <icon name="lucide:check" />
</template>

<style scoped></style>
